import React, { useContext, useEffect, useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'
import { addcontext } from '../../ContextShare/ContextShare';
import { getVideoListForTag } from '../../Services/allApi';
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import EditOrAddTags from './EditOrAddTags';
import AddTimeline from './AddTimeline';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '85%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90%',
    overflowY: 'auto' // Make the Box scrollable
};
function TagVideoList({ dateForTag, setIsTagPageOpen }) {
    const [videoData, setVideoData] = useState([])
    const [dataToEdit, setDataToEdit] = useState()
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => { setOpen(false); setDataToEdit() }
    const [videoIdToModal, setvideoIdToModal] = useState()
    const [open2, setOpen2] = useState(false);
    const handleOpen2 = () => setOpen2(true);
    const handleClose2 = () => { setOpen2(false); setDataToEdit() }
    const [openSS, setOpenSS] = useState(false);
    const handleOpenSS = () => setOpenSS(true);
    const handleCloseSS = () => setOpenSS(false);
    const [openTL, setOpenTL] = useState(false);
    const handleOpenTL = () => setOpenTL(true);
    const handleCloseTL = () => setOpenTL(false);

    const customStyles = {
        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '40px',
                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '40px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '40px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '40px'
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',
            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '50px',
            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
    };
    const columns = [
        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,
        },
        {
            name: 'Id',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: 'Seq no',
            selector: row => row.seqno,
            sortable: true,
        },
        {
            name: 'KLA',
            selector: row => row.KLA,
            sortable: true,
        },
        {
            name: 'Session',
            selector: row => row.Session,
            sortable: true,
        },
        {
            name: 'Event',
            selector: row => row.Event,
            sortable: true,
        },
        {
            name: 'Member',
            selector: row => row.Member,
            sortable: true,
        },
        {
            name: 'Subject',
            selector: row => row.title,
            sortable: true,
        },
        {
            name: 'Date',
            selector: row => row.Date,
            sortable: true,
        },
        {
            name: 'Tags',
            selector: row => row.Tags,
        },
    ];
    var data = []
    videoData?.length > 0 && videoData?.map((item, index) => {
        const slno = index + 1;
        const id = item.video_id;
        const seqno = item.video_sequence_no;
        const KLA = item.kla;
        const Session = item.video_session;
        const Event = item.video_event;
        const Member = item.video_member;
        const title = item.video_subject;
        const Date = item.video_upload_date;
        const ParentId = item.parent_video;
        const PartOrder = item.part_order;
        const UploadedBy = item.uploaded_by;
        const CreatedAt = item.created_at?.slice(0, 10);
        const UpldatedAt = item.updated_at?.slice(0, 10);
        const Tags = <a onClick={() => handleEdit(item)} style={{ color: '#18A0FB', cursor: 'pointer' }} >Edit / Add</a>
        const Timeline = <a onClick={() => handleEditTimeline(item)} style={{ color: '#18A0FB', cursor: 'pointer' }} >Edit / Add</a>
        const newObj = { id, seqno, slno, title, KLA, Session, Event, Member, Date, ParentId, PartOrder, UploadedBy, CreatedAt, UpldatedAt, Tags, Timeline };
        data.push(newObj);
    })

    const handleEdit = (item) => {
        setvideoIdToModal(item?.mapping_id)
        handleOpenSS()
    }

    const handleEditTimeline = (item) => {
        setvideoIdToModal(item?.video_id)
        handleOpenTL()
    }

    useEffect(() => {
        geVideoList()
    }, [dateForTag])

    const geVideoList = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const res = await getVideoListForTag({ 'date': dateForTag }, reqHeader)
        console.log(res);
        setVideoData(res?.data?.data)
    }

    return (
        <>
            <div><button onClick={() => setIsTagPageOpen(false)} className='hover:bg-success rounded flex justify-start mt-2 mb-2 items-center'><Icon icon="ic:baseline-arrow-back" className='text-lg' /><span className='ms-1 me-1'>Back to home</span></button></div>
            <DataTable
                title=""
                columns={columns}
                data={data}
                customStyles={customStyles}
                pagination
                dense
                highlightOnHover
                selectableRowsHighlight
                paginationPerPage={25} // Initial page size
                paginationRowsPerPageOptions={[25, 50, 100, 150, 200]} // Options for users to change page size
            />

            <Modal
                open={openSS}
                onClose={handleCloseSS}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <EditOrAddTags handleCloseModalSS={handleCloseSS} videoId={videoIdToModal} />
                </Box>
            </Modal>

            <Modal
                open={openTL}
                onClose={handleCloseTL}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <AddTimeline handleCloseModalTL={handleCloseTL} videoId={videoIdToModal} />
                </Box>
            </Modal>
        </>
    )
}

export default TagVideoList